import { render } from "./BookList.vue?vue&type=template&id=5505e4fa&scoped=true"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5505e4fa"

export default script